import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const AboutUsSectionThunk = createAsyncThunk(
	"AboutUsSectionThunk",
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				"https://api.msr7unaizah-com-606441.hostingersite.com/api/public/who_are_we"
			);

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
